import { useMemo } from 'react';

import type { AvailableCarrier, CarrierQuote } from 'api/quote-marketplace';
import { useQuoteMarketplaceTheme } from './useQuoteMarketplaceTheme';

interface UseComparisonTableHelpersProps {
  carrierQuotes: CarrierQuote[];
  selectedCarrierQuoteId: number | null;
  rfqStatus: string;
}

export const useComparisonTableHelpers = ({
  carrierQuotes,
  selectedCarrierQuoteId,
  rfqStatus,
}: UseComparisonTableHelpersProps) => {
  const theme = useQuoteMarketplaceTheme();

  const isLoading = rfqStatus === 'submitted' || rfqStatus === 'polling';

  const getQuoteForCarrier = useMemo(() => {
    return (carrier: AvailableCarrier): CarrierQuote | undefined => {
      return carrierQuotes.find((q) => q.acturis_product === carrier.product);
    };
  }, [carrierQuotes]);

  const isCarrierSelected = useMemo(() => {
    return (carrier: AvailableCarrier): boolean => {
      const quote = getQuoteForCarrier(carrier);
      return quote?.id === selectedCarrierQuoteId;
    };
  }, [getQuoteForCarrier, selectedCarrierQuoteId]);

  return {
    theme,
    isLoading,
    getQuoteForCarrier,
    isCarrierSelected,
  };
};
